import { HttpRequest } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserService } from "src/app/shared/service/user-service";
import { LocalStorageUtil } from "src/app/shared/utils/local-storage/local-storage-util";

@Component({
    selector: "session-expired-dialog",
    templateUrl: "./session-expired-dialog.component.html",
    styleUrls: ['./session-expired-dialog.component.scss'],

})
export class SessionExpiredDialog {
    isLoaderEnabled: boolean = false;
    currentHTTPClientUrl;

    constructor(private router: Router, private dialog: MatDialog, public dialogRef: MatDialogRef<SessionExpiredDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public userService: UserService, private localStorageUtil: LocalStorageUtil) {
        if (data) {
            this.currentHTTPClientUrl = data.url;
        }
        this.userService.setSessionExpiredDialogOpened(true);  
    }

    ngOnInit() { }

    onCancel(): void { this.dialogRef.close(null); }

    //navigates to login page
    login() {
        this.dialogRef.close(null);
        this.dialog.closeAll(); //for closing all dialogs when its login page
        this.router.navigate(['careers/auth'], { queryParams: { url: this.router.url }, replaceUrl: true });
        this.userService.setPreventData(false);
    }

    // navigates to the open positions page
    home() {
        this.localStorageUtil.clearLocalStorage();
        this.router.navigateByUrl('', { replaceUrl: true });
        this.dialogRef.close(null);
    }

    withOutLogin() {
        this.userService.setPreventData(false);
        if (this.currentHTTPClientUrl?.includes("secure") || this.router.url.includes("my-profile") || this.router.url.includes("my-careers/jobs")) {
            this.home();
        } else {
            this.onCancel();
            this.userService.setClearLocalStorage('clear');
        }
    }

}